import React from "react";
import "./ServiceSection.css";
import Heading from "../Heading/Heading";
import section_image_3 from "../../assets/images/section_image_3.png";
import transport from "../../assets/icons/transport.png";
import network from "../../assets/icons/network.png";
import contract from "../../assets/icons/contract.png";

export default function ServiceSection() {
  return (
    <div className="services padding_top_bottom">
      <Heading MainHeader="OUR SERVICES" />
      <div className="container">
        <div className="row section_align_items ">
          <div className="service_image layout-col-lg-6 layout-col-sm-12">
            <img src={section_image_3} alt="service section" />
          </div>
          <div className="list_services layout-col-lg-6 layout-col-sm-12">
            <h1>Turnkey EPC Projects</h1>
            <h2>The Scope of our Turnkey Offering includes:</h2>
            <ul>
              <li>
                The supply, installation and commissioning of MV and LV Overhead
                Lines.
              </li>
              <li>
                The supply, installation, commissioning and refurbishment of
                transmission and distribution substations.
              </li>
              <li>Tower and foundation design</li>
              <li>Route surveying</li>
              <li>Line pegging.</li>
            </ul>
          </div>
        </div>

        <div className="our_strength">
          <div className="project_strenth_title">
            <h2>Our strengths are in the following areas</h2>
            <h1>Turnkey EPC Projects</h1>
          </div>
          <div className="strengths row">
            <div className="strength_item layout-col-lg-4 layout-col-md-4 layout-col-sm-12">
              <img src={network} alt="network" />
              <h2>Extensive network</h2>
              <p>
                Extensive network of qualified and certified suppliers and
                manufacturers
              </p>
            </div>
            <div className="strength_item layout-col-lg-4 layout-col-md-4 layout-col-sm-12">
              <img src={transport} alt="transport" />
              <h2>In-house transport</h2>
              <p>
                Extensive network of qualified and certified suppliers and
                manufacturers
              </p>
            </div>
            <div className="strength_item layout-col-lg-4 layout-col-md-4 layout-col-sm-12">
              <img src={contract} alt="contract" />
              <h2>International experience</h2>
              <p>
                International experience in Letters of Credit and other forms of
                contracts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
